const steps = ['profile', 'question', 'summary']

const stepChecker = (step: string, request: string) => {
  return steps.indexOf(step.toLowerCase()) < steps.indexOf(request)
}

export default stepChecker

